import React, { useEffect, useContext } from 'react'

// Context
import { CasFormatDispatch } from 'context/cas-format-context'

interface Props {
  format: string,
  file: string
}

const CASFormat = ({ format, file }:Props) => {
  const casFormatDispatch = useContext(CasFormatDispatch)

  useEffect(()=> {
    casFormatDispatch({
      type: 'add', 
      value:{
        key: format, 
        value: file
      }
    })
  },[casFormatDispatch]) /* eslint-disable-line */

  return <React.Fragment />
}

export default CASFormat